// extracted by mini-css-extract-plugin
export default {"BreakpointFromMedium":"(min-width: 640px)","title":"G918c55","rafTitle":"G07c9c3"};